import CalendarIcon from "@atlaskit/icon/core/calendar";
import NodeIcon from "@atlaskit/icon/core/node";
import RoadmapIcon from "@atlaskit/icon/core/roadmap";
import {token} from "@atlaskit/tokens";

const metaIconStyle = {
    color: token("color.icon.subtlest"),
    width: 16,
    height: 16,
};

export function JourneyProgressCardMeta({
    createdAtLabel,
    onDisposeClick,
}: {
    createdAtLabel: string;
    onDisposeClick: () => void;
}) {
    return (
        <div className="flex h-ds-space-300 w-full min-w-0 items-center gap-x-ds-space-050">
            <span
                className="inline-flex shrink-0 items-center justify-center"
                style={metaIconStyle}
            >
                <CalendarIcon
                    label=""
                    size="medium"
                />
            </span>
            <span
                className="truncate text-[0.75rem] leading-ds-space-200"
                style={{color: token("color.text.subtlest"), fontFamily: "Inter"}}
            >
                {createdAtLabel}
            </span>
            <span
                className="inline-flex shrink-0 items-center"
                style={{color: token("color.icon.subtle")}}
            >
                <NodeIcon
                    label=""
                    size="small"
                />
            </span>
            <button
                type="button"
                aria-label="Dispose"
                onClick={(event) => {
                    event.stopPropagation();
                    onDisposeClick();
                }}
                className="inline-flex shrink-0 items-center justify-center border-0 bg-transparent p-0"
                style={metaIconStyle}
            >
                <RoadmapIcon
                    label=""
                    size="medium"
                />
            </button>
        </div>
    );
}
